// extracted by mini-css-extract-plugin
export default {"row":"FacetToggle_row__hJzQk","facetToggle":"FacetToggle_facetToggle__0CXfv"};